/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {CONDITIONAL_DIRECTIVES} from './index';
export class ClrConditionalModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{imports: [CommonModule], declarations: [CONDITIONAL_DIRECTIVES], exports: [CONDITIONAL_DIRECTIVES]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrConditionalModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrConditionalModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrConditionalModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
